
/* ── SITE-WIDE FONT + CART DRAWER STYLE ── */
(function(){
  var G='"EB Garamond",Georgia,serif';
  var css=''
  +'body,body *:not(svg):not(path):not(circle):not(line):not(rect):not(ellipse){font-family:'+G+'!important}'
  +'body{font-size:17px}'
  +'.ann,.ann span{font-size:13px!important;letter-spacing:2px!important}'
  +'.nav-link{font-size:14px!important;letter-spacing:2px!important}'
  +'button,.btn-atc,.btn-buynow,.btn-checkout,.feat-btn,.hero-btn,.ep-btn,.gtl-btn{letter-spacing:2px!important}'
  +'.product-page .prod-title,h1.prod-title{color:#4A2C86!important}'
  +'.product-page .rel-name,.cart-item-title,.gk-ci-name,.tri-name,.trend-name,.na-name,.product-card__title,.grid-product__title{color:#4A2C86!important}'
  +'.cart-h,.related-h,.cart-summary h3{color:#4A2C86!important}'
  +'.product-page .prod-actions button,.product-page .btn-atc,.product-page .btn-buynow{font-size:15px!important}'
  +'.product-page .option-label,.product-page .qty-label,.product-page .acc-toggle,.product-page .breadcrumb{font-size:13px!important;letter-spacing:2px!important}'
  +'.product-page .opt-btn{font-size:15px!important}'
  +'.product-page .trust-item{font-size:14.5px!important}'
  +'.size-modal .size-sub,.size-modal .size-table th,.site-footer .footer-pay-icons span,.site-footer .pol-body th,.gk-menu .pol-body th{font-size:13px!important;letter-spacing:1.5px!important}'
  +'.cart-drawer{display:flex!important;flex-direction:column!important;background:#FAF7F4!important;width:min(420px,92vw)!important}'
  +'.cart-drawer .drawer-head{display:flex;justify-content:space-between;align-items:center;padding:20px 22px 14px!important;border-bottom:1px solid #ECE6E0;background:#FAF7F4;flex-shrink:0}'
  +'.cart-drawer .drawer-title{font-size:25px!important;letter-spacing:.2px!important;text-transform:none!important;color:#4A2C86!important;font-weight:500}'
  +'.cart-drawer .drawer-close{color:#4A2C86!important;font-size:20px!important;background:none;border:none;cursor:pointer}'
  +'.gk-ship{padding:14px 22px 12px;border-bottom:1px solid #ECE6E0;flex-shrink:0}'
  +'.gk-ship p{margin:0 0 8px;font-size:16px;color:#4A2C86}'
  +'.gk-ship p b{color:#C8177A}'
  +'.gk-ship .bar{height:6px;background:#EDE3F0;border-radius:99px;overflow:hidden}'
  +'.gk-ship .bar span{display:block;height:100%;background:linear-gradient(90deg,#EC2790,#4A2C86);border-radius:99px;transition:width .4s}'
  +'.cart-drawer .drawer-items{flex:1 1 auto!important;overflow-y:auto!important;padding:6px 22px!important}'
  +'.cart-drawer .drawer-empty{text-align:center;padding:60px 0;font-size:20px;color:#6B5578;font-style:italic}'
  +'.gk-ci{display:grid;grid-template-columns:84px 1fr;gap:14px;padding:16px 0;border-bottom:1px solid #ECE6E0}'
  +'.gk-ci img{width:84px;height:108px;object-fit:cover;border-radius:4px;display:block;background:#F1ECE6}'
  +'.gk-ci-name{font-size:18px;line-height:1.3;margin:0 0 4px;text-decoration:none;display:block}'
  +'.gk-ci-var{font-size:13px;letter-spacing:1.5px;text-transform:uppercase;color:#8A7C92;margin-bottom:8px}'
  +'.gk-ci-row{display:flex;justify-content:space-between;align-items:center;gap:10px}'
  +'.gk-qty{display:inline-flex;align-items:center;border:1px solid #D9CFE0;border-radius:99px;overflow:hidden}'
  +'.gk-qty button{background:none;border:none;width:30px;height:30px;font-size:18px;color:#4A2C86;cursor:pointer;letter-spacing:0!important}'
  +'.gk-qty span{min-width:22px;text-align:center;font-size:16px;color:#2A1B1F}'
  +'.gk-ci-price{font-size:18px;color:#4A2C86;font-weight:600}'
  +'.gk-ci-rm{background:none;border:none;padding:0;margin-top:8px;font-size:13px;letter-spacing:1.5px!important;text-transform:uppercase;color:#9A8CA3;cursor:pointer;text-decoration:underline}'
  +'.gk-ci-rm:hover{color:#C8177A}'
  +'.cart-drawer .drawer-footer{flex-shrink:0;padding:16px 22px 22px!important;border-top:1px solid #ECE6E0;background:#fff;box-shadow:0 -6px 18px rgba(74,44,134,.06)}'
  +'.cart-drawer .drawer-subtotal{display:flex;justify-content:space-between;align-items:baseline;font-size:20px!important;color:#2A1B1F!important;margin-bottom:2px}'
  +'.cart-drawer .drawer-subtotal span:last-child{font-weight:600;color:#4A2C86}'
  +'.cart-drawer .drawer-ship-note{font-size:14.5px!important;font-style:italic;color:#8A7C92!important;margin:0 0 14px!important}'
  +'.cart-drawer .drawer-checkout{background:#4A2C86!important;color:#fff!important;border:none!important;border-radius:4px;padding:15px 0!important;font-size:16px!important;letter-spacing:3px!important;text-transform:uppercase;text-decoration:none!important}'
  +'.cart-drawer .drawer-checkout:hover{background:#3A2270!important}'
  +'.gk-secure{text-align:center;font-size:13px;letter-spacing:1.5px;text-transform:uppercase;color:#8A7C92;margin:10px 0 4px}'
  +'.cart-drawer .drawer-view-cart{display:block;text-align:center;margin-top:6px;font-size:13px;letter-spacing:2px;text-transform:uppercase;color:#4A2C86!important;text-decoration:underline}'
  +'#gkWaBox{position:fixed;inset:0;background:rgba(42,27,31,.45);display:none;align-items:center;justify-content:center;z-index:10000}'
  +'#gkWaBox.open{display:flex}'
  +'#gkWaBox .bx{background:#fff;border-radius:12px;padding:24px 22px 16px;max-width:340px;width:88vw;text-align:center;box-shadow:0 20px 50px rgba(0,0,0,.25)}'
  +'#gkWaBox h3{margin:0 0 4px;font-size:23px;color:#4A2C86}'
  +'#gkWaBox p{margin:0 0 12px;font-size:15px;color:#6B5578}'
  +'#gkWaBox img{width:190px;height:190px;display:block;margin:0 auto 10px;border:1px solid #ECE6E0;border-radius:8px;padding:6px;background:#fff}'
  +'#gkWaBox .num{font-size:20px;color:#4A2C86;font-weight:600;margin:0 0 14px}'
  +'#gkWaBox a,#gkWaBox button{display:block;width:100%;box-sizing:border-box;padding:12px;border-radius:4px;font-size:14px;letter-spacing:1.5px;text-transform:uppercase;margin:0 0 8px;cursor:pointer;text-decoration:none}'
  +'#gkWaBox .go{background:#25D366;color:#fff!important;border:none}'
  +'#gkWaBox .cp{background:#fff;color:#4A2C86;border:1px solid #4A2C86}'
  +'#gkWaBox .cl{background:none;border:none;color:#8A7C92;margin:0}';
  var s=document.createElement('style');s.id='gkFontCart';s.textContent=css;document.head.appendChild(s);
})();

/* ── WHATSAPP WITHOUT THE WHATSAPP WEBSITE ──
   Phones: open the WhatsApp app directly (whatsapp://).
   Computers: show a box with QR code + Desktop app + copy buttons. */
(function(){
  var DEF_PHONE='919987754254', NUM_LABEL='+91 99877 54254';
  function isWa(h){return /(wa\.me|whatsapp\.com)/i.test(h||'')}
  function parse(url){
    var phone=DEF_PHONE, text='';
    try{
      var m=url.match(/wa\.me\/(\d+)/i)||url.match(/[?&]phone=(\d+)/i); if(m) phone=m[1];
      var t=url.match(/[?&]text=([^&]*)/i); if(t) text=decodeURIComponent(t[1].replace(/\+/g,'%20'));
    }catch(e){}
    return {phone:phone,text:text};
  }
  function appLink(p){return 'whatsapp://send?phone='+p.phone+(p.text?'&text='+encodeURIComponent(p.text):'')}
  function isMobile(){return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent)}
  function copy(t,btn){
    function done(){btn.textContent='Copied ✓';setTimeout(function(){btn.textContent=btn.dataset.l},1600)}
    try{navigator.clipboard.writeText(t).then(done,function(){prompt('Copy this:',t)})}catch(e){prompt('Copy this:',t)}
  }
  function box(p){
    var b=document.getElementById('gkWaBox');
    if(!b){b=document.createElement('div');b.id='gkWaBox';document.body.appendChild(b);b.addEventListener('click',function(e){if(e.target===b)b.classList.remove('open')});}
    var waUrl='https://wa.me/'+p.phone+(p.text?'?text='+encodeURIComponent(p.text):'');
    var qr='https://api.qrserver.com/v1/create-qr-code/?size=360x360&margin=0&data='+encodeURIComponent(waUrl);
    b.innerHTML='<div class="bx"><h3>Chat on WhatsApp</h3><p>Scan with your phone camera to open WhatsApp</p>'
      +'<img src="'+qr+'" alt="WhatsApp QR code"/>'
      +'<div class="num">'+NUM_LABEL+'</div>'
      +'<a class="go" href="'+appLink(p)+'">Open WhatsApp Desktop</a>'
      +(p.text?'<button type="button" class="cp" id="gkWaMsg" data-l="Copy my message">Copy my message</button>':'')
      +'<button type="button" class="cp" id="gkWaNum" data-l="Copy number">Copy number</button>'
      +'<button type="button" class="cl" id="gkWaClose">Close</button></div>';
    var m=document.getElementById('gkWaMsg'); if(m) m.onclick=function(){copy(p.text,m)};
    var n=document.getElementById('gkWaNum'); n.onclick=function(){copy(NUM_LABEL,n)};
    document.getElementById('gkWaClose').onclick=function(){b.classList.remove('open')};
    b.classList.add('open');
  }
  window.gkOpenWa=function(url){
    var p=parse(url||'');
    if(isMobile()){
      var t0=Date.now();
      try{ (window.top===window.self?window:window.top).location.href=appLink(p); }catch(e){ window.location.href=appLink(p); }
      setTimeout(function(){ if(!document.hidden && Date.now()-t0<2500) box(p); },1500);
    } else {
      box(p);
    }
  };
  document.addEventListener('click',function(e){
    var a=e.target&&e.target.closest?e.target.closest('a[href]'):null;
    if(!a||(a.closest&&a.closest('#gkWaBox'))) return;
    var h=a.getAttribute('href');
    if(!isWa(h)) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    window.gkOpenWa(h);
  },true);
})();

/* ── CART DRAWER ── */
function openCart(){
  document.getElementById("cartDrawer").classList.add("open");
  document.getElementById("drawerBg").classList.add("open");
  refreshCart();
}
function closeCart(){
  document.getElementById("cartDrawer").classList.remove("open");
  document.getElementById("drawerBg").classList.remove("open");
}
function gkEsc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
function ensureShipBar(){
  var d=document.getElementById('cartDrawer'); if(!d) return null;
  var b=document.getElementById('gkShip');
  if(!b){b=document.createElement('div');b.id='gkShip';b.className='gk-ship';var items=document.getElementById('cartItems');d.insertBefore(b,items);}
  return b;
}
function refreshCart(){
  fetch("/cart.js")
    .then(r=>r.json())
    .then(cart=>{
      var el=document.getElementById("cartItems");
      var count=cart.item_count;
      document.querySelectorAll(".cart-dot").forEach(d=>d.textContent=count);
      var t=document.querySelector('#cartDrawer .drawer-title'); if(t) t.textContent='Your Cart'+(count?' ('+count+')':'');
      var ship=ensureShipBar();
      if(!el) return;
      if(count===0){
        el.innerHTML='<div class="drawer-empty">Your cart is empty<br><a href="/collections/all" style="display:inline-block;margin-top:14px;font-style:normal;font-size:13px;letter-spacing:2px;text-transform:uppercase;color:#4A2C86">Start shopping →</a></div>';
        document.getElementById("drawerFooter").style.display="none";
        if(ship) ship.style.display='none';
        return;
      }
      document.getElementById("drawerFooter").style.display="block";
      var html=cart.items.map(function(item){
        var v=(item.variant_title&&item.variant_title!=="Default Title")?'<div class="gk-ci-var">Size: '+gkEsc(item.variant_title)+'</div>':'';
        return '<div class="gk-ci">'
          +'<a href="'+item.url+'"><img src="'+item.image+'" alt="'+gkEsc(item.product_title)+'"/></a>'
          +'<div><a class="gk-ci-name" href="'+item.url+'">'+gkEsc(item.product_title)+'</a>'+v
          +'<div class="gk-ci-row"><div class="gk-qty"><button type="button" aria-label="Decrease" onclick="updateQty(\''+item.key+'\','+(item.quantity-1)+')">−</button><span>'+item.quantity+'</span><button type="button" aria-label="Increase" onclick="updateQty(\''+item.key+'\','+(item.quantity+1)+')">+</button></div>'
          +'<div class="gk-ci-price">'+formatMoney(item.final_line_price)+'</div></div>'
          +'<button type="button" class="gk-ci-rm" onclick="updateQty(\''+item.key+'\',0)">Remove</button>'
          +'</div></div>';
      }).join("");
      el.innerHTML=html;
      document.getElementById("drawerSubtotal").textContent=formatMoney(cart.total_price);
      var freeAt=149900;
      var rem=freeAt-cart.total_price;
      var note=document.getElementById("drawerShipNote");
      note.textContent="Taxes included. Discounts applied at checkout.";
      if(ship){
        ship.style.display='block';
        var pct=Math.min(100,Math.round(cart.total_price/freeAt*100));
        ship.innerHTML=(rem>0?'<p>Add <b>'+formatMoney(rem)+'</b> more for <b>FREE</b> shipping</p>':'<p>✓ You\'ve unlocked <b>FREE</b> shipping</p>')+'<div class="bar"><span style="width:'+pct+'%"></span></div>';
      }
      var foot=document.getElementById('drawerFooter');
      if(foot && !document.getElementById('gkSecure')){
        var s=document.createElement('div');s.id='gkSecure';s.className='gk-secure';s.textContent='🔒 Secure checkout · UPI · Cards · COD';
        var vc=foot.querySelector('.drawer-view-cart'); foot.insertBefore(s,vc);
      }
    });
}
function formatMoney(cents){
  return "₹"+new Intl.NumberFormat("en-IN").format(cents/100);
}
function addToCart(variantId,qty,properties){
  var body={items:[{id:variantId,quantity:qty||1}]};
  if(properties) body.items[0].properties=properties;
  fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(body)})
    .then(r=>r.json())
    .then(function(){openCart();});
}
function updateQty(key,qty){
  if(qty<0) qty=0;
  fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:key,quantity:qty})})
    .then(r=>r.json()).then(function(){
      refreshCart();
      if(document.querySelector(".cart-page")) location.reload();
    });
}

/* ── NAV SCROLL ── */
window.addEventListener("scroll",function(){
  document.getElementById("mainNav")&&document.getElementById("mainNav").classList.toggle("scrolled",window.scrollY>10);
});

/* ── CATEGORY FAN ── */
document.addEventListener("DOMContentLoaded",function(){
  document.querySelectorAll(".cf").forEach(function(c){
    c.addEventListener("mouseleave",function(){setTimeout(function(){c.style.zIndex="";},350);});
  });
  refreshCart();
});
